import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import {colors} from "@mui/material";

const customComponents = {
    custom: {
        sidebar: {
            width: 250
        }
    }
};

const theme = createTheme({
    palette: {
        primary: {
            contrastText: '#FFFFFF',
            dark: '#b83d16',
            main: '#ee722d',
            light: '#f5b226'
        },
        secondary: {
            contrastText: '#FFFFFF',
            dark: '#1B2132',
            main: '#43537b',
            light: '#8292BB'
        },
        disabled: {
            main: colors.grey[500],
            dark: colors.grey[700],
            light: colors.grey[300],
            contrastText: colors.grey[50]
        },
        white: {
            main: colors.common.white,
            contrastText: colors.grey[800]
        },
        background:{
            default: "#fafafa"
        }
    },
}, customComponents);

export default responsiveFontSizes(theme);